"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var lodash_1 = require("lodash");
var papaparse_1 = __importDefault(require("papaparse"));
var ParseLineItem_1 = __importDefault(require("./ParseLineItem"));
var isCsvFileType = function (file) {
    if (file.type === "text/csv") {
        return true;
    }
    else if (file.name != null) {
        var lowerName = file.name.toLowerCase();
        var extension = lowerName.substring(lowerName.length - 3);
        return extension === "csv";
    }
    return false;
};
exports.default = (function (invoke) {
    return function ($q, file) {
        var gettingData = $q.defer();
        var parseItem = invoke(ParseLineItem_1.default);
        if (file.type == null || !isCsvFileType(file)) {
            var err = new Error("Invalid file type, the file was not recognised to be a CSV file.");
            gettingData.reject(err);
        }
        else {
            papaparse_1.default.parse(file, {
                header: true,
                skipEmptyLines: true,
                error: function (err) {
                    return gettingData.reject(err);
                },
                complete: function (results) {
                    var e_1, _a;
                    var items = [];
                    try {
                        for (var _b = __values(results.data), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var rawItem = _c.value;
                            var item = parseItem(rawItem);
                            if (!(0, lodash_1.isNil)(item)) {
                                if (!(item.type === Types_1.QuoteItemType.Text && !item.description)) {
                                    items.push(item);
                                }
                            }
                            else {
                                var err = new Error("This CSV file did not seem to have the correct columns");
                                gettingData.reject(err);
                                return;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return gettingData.resolve(items);
                },
            });
        }
        return gettingData.promise;
    };
});
